module.exports = __webpack_public_path__ + "media/images/fantasy_logo-154407a70b3da93046148924de36dfdb.svg";